import { QME_APPOINTMENT_STATUS } from "../common/Constant";
import { handleApiError } from "../utils/apiUtils";
import api from "./Api";

const Case = process.env.REACT_APP_CASE_URL;

if (!Case) {
  throw new Error(
    "BASE_URL is undefined. Please set REACT_APP_CASE_URL in your environment variables."
  );
}

const caseAPI = api(Case);

export const GetAppointmentList = async (
  caseInfoId: number,
  searchString?: string
): Promise<any> => {
  try {
    const response = await caseAPI.get(
      `/api/appointment/list?caseInfoId=${caseInfoId}&searchText=${searchString}`
    );

    const updatedResult = response.data?.result.map((address: any) => ({
      ...address,
      actions: { Edit: "Edit" }, // Adding Edit action inside each address entry
    }));

    return updatedResult;
  } catch (error) {
    console.error("Error fetching the address list:", error);
    throw new Error("Unable to fetch address data. Please try again later.");
  }
};

export const AppointmentBulkUpdateStatus = async (
  payload: any
): Promise<any> => {
  try {
    const response = await caseAPI.post(
      `/api/appointment/bulk/update/status`, payload
    );

    return response.data ?? [];
  } catch (error) {
    return handleApiError(error);
  }
};